// extracted by mini-css-extract-plugin
export var borderRadius = "_ah-4";
export var large = "_ah-3";
export var logoContainer = "_ah-0";
export var nameLogo = "_ah-2";
export var small = "_ah-1";